module.exports = __webpack_public_path__ + "static/images/fe5819a31d95450d7370db3025d1a262.png";